<script>
	import { onMount } from 'svelte';
	import { noSelectorReturn } from '../../share/noSelectorReturn';
	
	export let html;
	
	let div;
	let style = '';
	let counters = [];
	const numbers = 5;
	
	function animateCountersIfInView() {
		
		// left and right side with active counter
		setTimeout(() => {
			noSelectorReturn(div, '.number__window');
			requestAnimationFrame(animateCountersIfInView);
		}, 1000);
		
		// right side can be without counter
		if (!div) {
			return;
		}
		
		let i = 1;
		Array.from(div.querySelectorAll('.number__window')).forEach((counter) => {
			const digits = counter.querySelector('.number__window__digit');
			const counterTop = counter.getBoundingClientRect().y;
			if (counterTop < window.innerHeight) {
				Array.from(counter.querySelectorAll('.number__window__digit')).forEach((numberWindowDigitDiv) => {
					// overwrite "0" at the beginning:
					if(numberWindowDigitDiv.setRealNumbers) {
						numberWindowDigitDiv.setRealNumbers();
						numberWindowDigitDiv.setRealNumbers = false;
					}
				})
				digits.style.animationDelay = `calc(var(--set_offset, 0) + ${i++ * 0.3}s)`;
				counter.classList.add('animate');
			}
		});
	}
	
	function initCounterValues(counter) {
		const animate_numbers_element = counter.querySelector('.animate_numbers');
		const prefix = animate_numbers_element.getAttribute('prefix') || '';
		const suffix = animate_numbers_element.getAttribute('suffix') || '';
		let start = animate_numbers_element.getAttribute('start');
		let end = animate_numbers_element.getAttribute('end')

			//reverse
			.split('').reverse().join('')
			.match(/.{1,3}/g).join('.')

			//original order
			.split('').reverse().join('');
		const animationTime = animate_numbers_element.getAttribute('animation_time');
		const animationOffset = animate_numbers_element.getAttribute('animation_offset');
		const numbersLength = Math.max(start.length, end.length);
		start = start.padStart(numbersLength, ' ');
		end = end.padStart(numbersLength, ' ');
		return {
			prefix: prefix,
			suffix: suffix,
			start: start,
			end: end,
			animationTime: animationTime,
			animationOffset: animationOffset,
			numbersLength: numbersLength
		};
	}
	
	function createCountersFromHtml(tempDiv) {
		const counterDivs = tempDiv.querySelectorAll('.counter');
		const countersGridDiv = document.createElement('div');
		div.appendChild(countersGridDiv);
		
		Array.from(counterDivs).forEach((counter) => {
			const counterValues = initCounterValues(counter);
			const numbersDiv = document.createElement('div');
			numbersDiv.classList.add('numbers');
			
			if (counterValues.prefix) {
				const prefixDiv = document.createElement('span');
				prefixDiv.classList.add('number__static');
				prefixDiv.innerHTML = counterValues.prefix;
				numbersDiv.appendChild(prefixDiv);
			}
			for (let i = 0; i < counterValues.numbersLength; i++) {
				const numberWindowDiv = document.createElement('span');
				numberWindowDiv.classList.add('number__window');
				numbersDiv.appendChild(numberWindowDiv);
				const numberWindowDigitDiv = document.createElement('span');
				numberWindowDigitDiv.classList.add('number__window__digit');
			
				// as the numbers rotate in .5s the last one has to rotate as much as the full set animationTime
				// the numbers before halt at one interation less than the next one
				let interationCount = counterValues.animationTime / 1000 / 0.5;
				interationCount = interationCount - counterValues.numbersLength + i + 1;
				numberWindowDigitDiv.style.animationIterationCount = Math.max(1, interationCount);
				let fakeCounter = counterValues.start[i] === ' ' ? numbers - 1 : numbers;
				let dataFake = '';
				if (counterValues.start[i] === ' ') {
					numberWindowDigitDiv.classList.add('start_empty');
				}
				else {
					dataFake = counterValues.start[i];
				}
				for (let j = 1; j < fakeCounter; j++) {
					dataFake = dataFake.toString() + Math.floor(Math.random() * 10);
				}
				numberWindowDigitDiv.setAttribute('data-fake', dataFake);

				// start with "0"
				numberWindowDigitDiv.innerHTML = counterValues.start[i] || ' ';
				numberWindowDigitDiv.setRealNumbers = () => {
					// the final number is needed for the animation, so overwrite "0" when inView:
					numberWindowDigitDiv.innerHTML = counterValues.end[i] || ' ';
				}
				numberWindowDiv.style.setProperty('--number-height', numbers);
				numberWindowDiv.appendChild(numberWindowDigitDiv);
			}
			if (counterValues.suffix) {
				const suffixDiv = document.createElement('span');
				suffixDiv.classList.add('number__static');
				suffixDiv.innerHTML = counterValues.suffix;
				numbersDiv.appendChild(suffixDiv);
			}
			if (counterValues.animationOffset) {
				numbersDiv.style.setProperty('--set_offset', counterValues.animationOffset / 1000 + 's');
			}
			const counterDiv = document.createElement('div');
			counterDiv.classList.add('counter');
			const textDiv = document.createElement('div');
			textDiv.classList.add('text');
			textDiv.innerHTML = counter.querySelector('.content').innerText;
			counterDiv.style = counter.getAttribute('style');
			counterDiv.appendChild(numbersDiv);
			counterDiv.appendChild(textDiv);
			countersGridDiv.appendChild(counterDiv);
			counters.push(counter);
			counters = counters;
		});
		animateCountersIfInView();
	}
	
	onMount(() => {
		const tempDiv = document.createElement('div');
		if(!html) {
			html = div.innerHTML;
		}
		tempDiv.innerHTML = html;
		style = tempDiv.querySelector('.counters div').getAttribute('style');
		tempDiv.querySelector('.counters').classList.forEach(className => {
			div.classList.add(className);
		})
		if (tempDiv.querySelector('h3')) {
			div.appendChild(tempDiv.querySelector('h3'));
		}
		createCountersFromHtml(tempDiv);
	});
</script>

<div bind:this={div} class="counters marginbox" style="{style}">
	{#if !html}
		<slot/>
	{/if}
	<!--
		Example: starts with "123" ends with " 45" and has "€" as unit:
	
		<div class="counter">
			<div class="numbers">
				<span class="number__window" style="--number-height: 3;">
					<span class="number__window_digit" style="animation-iteration-count: 2;" data-fake="123">
						::before
	
					</span>
				</span>
				<span class="number__window" style="--number-height: 3;">
					<span class="number__window_digit" style="animation-iteration-count: 2;" data-fake="234">
						::before
						4
					</span>
				</span>
				<span class="number__window" style="--number-height: 3;">
					<span class="number__window_digit" style="animation-iteration-count: 2;" data-fake="345">
						::before
						5
					</span>
				</span>
				<span class="number__static">
					€
				</span>
			</div>
		</div>
		-->
</div>

<style global lang="scss">
	@import "../../style/variables";
	@import "../../style/mixins";
	
	$digitHeight: 1em;
	$digitWidth: .65em;
	
	.counters {
		width: 100%;

		> div {
			display: grid;
			grid-template-columns: repeat(var(--cols_mobile), 1fr);
			
			@include for-tablet-portrait-up {
				grid-template-columns: repeat(var(--cols_tablet), 1fr);
			}
			
			@include for-desktop-up {
				grid-template-columns: repeat(var(--cols_desktop), 1fr);
			}
		}
		
		h3 {
			margin-bottom: $spacing-mobile;
		}
		
			.numbers {
			color: #FFF;
			font-size: 7rem;
			line-height: 1em;
			font-weight: 600;
			text-align: center;
			
			margin: 0 auto .5em;
			height: $digitHeight;
			
			overflow: hidden;
			
			--counter-height: 10;

			@include for-tablet-portrait-up {
				font-size: 5.5rem;
			}

			> * {
				float: left;
			}
		}
		
		.counter {
			text-align: center;
			display: flex;
			flex-direction: column;
			justify-content: center;
			aspect-ratio: 1;
		}
		
		.text {
			color: #FFF;
			@include font-px-to-rem(20, 30);
		}
		
		.number__static {
			display: block;
			height: $digitHeight;
		}
		
		.number__window {
			display: inline-block;
			overflow-x: visible;
			width: $digitWidth;
			height: $digitHeight;
		}
		
		.number__window__digit {
			font: inherit;
			word-break: break-all;
			
			display: block;
			width: 0;
			padding: 0 $digitWidth 0 0;
			margin: 0;
			overflow: inherit;
		}
		
		.animate .number__window__digit {
			animation: counting .5s forwards linear;
			
			&::before {
				content: attr(data-fake);
				display: inline-block;
				width: 100%;
				height: calc(#{$digitHeight} * var(--number-height));
			}
			
			&.start_empty::before {
				content: "\a" attr(data-fake);
				white-space: pre-wrap;
			}
		}
	}
	
	@keyframes counting {
		100% {
			transform: translate3d(0, calc(-#{$digitHeight} * var(--number-height)), 0)
		}
	}
</style>
